import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// ปัดขึ้นทศนิยม 2 ตำแหน่งเสมอ (เช่น 1.231 -> 1.24, -1.231 -> -1.23)
export function roundUp2(value) {
  const num = Number(value) || 0
  return Math.ceil(num * 100) / 100
}

export function formatCurrency(amount) {
  // ตรวจสอบและจำกัดค่าตัวเลขเพื่อป้องกัน overflow (อนุญาตค่าติดลบ)
  const safeAmount = Math.min(Math.max(Number(amount) || 0, -999999999999999.99), 999999999999999.99);
  
  // ตรวจสอบว่าเป็นตัวเลขที่ถูกต้องหรือไม่
  if (isNaN(safeAmount) || !isFinite(safeAmount)) {
    return '฿0.00';
  }
  
  try {
    const rounded = roundUp2(safeAmount)
    return new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
    }).format(rounded);
  } catch (error) {
    console.error('Error formatting currency:', error);
    return '฿0.00';
  }
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('th-TH')
}

// ตรวจสอบว่าเป็น mobile หรือไม่
export function isMobile() {
  return window.innerWidth <= 768
}

// จัดการ input สำหรับตัวเลข - ป้องกันการกรอกตัวอักษร
export function handleNumberInput(e, onChange) {
  const value = e.target.value
  
  // อนุญาตเฉพาะตัวเลข, จุดทศนิยม, และเครื่องหมายลบ
  const numericRegex = /^-?(\d+\.?\d*|\.\d+)$/
  
  // ถ้าเป็นค่าว่างหรือเป็นตัวเลขที่ถูกต้อง
  if (value === '' || numericRegex.test(value)) {
    onChange(e)
  } else {
    // ป้องกันการพิมพ์ตัวอักษร
    e.preventDefault()
  }
}
